export default __webpack_public_path__ + "static/media/alastortune.a5c06ffe.wav";